import Rate from 'bee-rate'

export default Rate
